// Versão exibida enquanto a versão real (tabela versoes_sistema, GET /api/versao) não é carregada
// ou se o backend estiver indisponível. A versão oficial AAAA.M.D.N vem do banco.
export const APP_VERSION = '—';
